<template>
  <div
    class="z-10 h-14 md:h-15 aha-presentation-editor-header"
    :class="{'in-demo-mode': isGuestUser, 'ppt-header': isEnableAddinPowerpoint}"
    v-if="presentation.id && renderPresentationDetail && !isPresentingPpt"
  >
    <!--z-10 for header box shadow to appear -->
    <EditorHeader @update-online-count="updatePresentationSessionOnlineCount" />
  </div>
</template>
<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import EditorHeader from '@/components-v2/presentation-editor/editor-header/EditorHeader.vue'
import PresentationApi from '@/api/presentation'

export default {
  components: {
    EditorHeader,
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapState({ // Do not delete anything here, since they might be called via imported functions
      presentation: (state) => state.presentation,
      renderPresentationDetail: (state) => state.renderPresentationDetail,
      isGuestUser: (state) => state.currentUser.isGuest,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
    ...mapGetters(['isPresenting']),
    isPresentingPpt() {
      if (this.isEnableAddinPowerpoint && this.isPresenting) return true
      return false
    },
  },
  mounted() {

  },
  destroyed() {
  },
  methods: {
    updatePresentationSessionOnlineCount: _.throttle((presentationId, onlineCount) => {
      PresentationApi.updateOnlineCountByPresentationId(presentationId, { onlineCount })
    }, 5000),
  },
}
</script>

<style lang="scss" scoped>
</style>
